/**
 * GENERATED — do not edit.
 *
 * Source: @oylo/schema (server_settings message) + src/schemas/overlay/.
 * Regenerate with `pnpm schema:gen`. tests/schema/drift.test.js gates this file.
 */
export default {
	type: 'object',
	properties: {
		upscale: {
			type: 'boolean',
			initial: true,
			label: 'HD resolution',
			tip: 'Upscale to x2 resolution',
		},
		output_layer: {
			type: 'string',
			initial: 'full',
			enum: [
				'full',
				'loopback',
				'control_depth',
				'control_edges',
				'control_pose',
				'post_control',
				'detail_map',
				'vae',
				'noise',
				'inpaint_mask',
				'objects_mask',
				'audio_debug',
				'audio_overlay',
			],
			kind: 'select',
		},
	},
}
